jQuery(function($){

$('.js-load-more-button').on('click', function() {
    let id = $(this).attr("data-id");
    let media = $(this).attr("data-media-type");
    let page = $(this).attr("data-page");
    let display = $(this).attr("data-display");
    let newPageNumber = Number(page);
    newPageNumber++;
    $(this).attr("data-page", newPageNumber);
    
    $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'json',
        data: {
            action: 'load_more_posts',
            paged: newPageNumber,
            media: media,
            display: display
        },
        success: function (res) {
            $(".js-load-more-section[data-id='" + id +"']").append(res);
            if(newPageNumber >= res.max) {
                $(".js-load-more[data-id='" + id +"']").hide();
            }
            $(".js-load-more-section[data-id='" + id +"']").append(res.html);
        }
    });

});

})